import { render, staticRenderFns } from "./Protocolos.vue?vue&type=template&id=05503954&scoped=true&"
import script from "./Protocolos.vue?vue&type=script&lang=js&"
export * from "./Protocolos.vue?vue&type=script&lang=js&"
import style0 from "./Protocolos.vue?vue&type=style&index=0&id=05503954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05503954",
  null
  
)

export default component.exports